import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDocumentMetadata } from '@hooks/useDocumentMetadata'
import LanguageService from '@services/LanguageService'

export default function LanguageDetector () {
  const navigate = useNavigate()

  useDocumentMetadata()

  useEffect(() => {
    // 1. Check localStorage first
    const storedLang = LanguageService.getStoredLanguage()

    if (storedLang) {
      navigate(`/${storedLang}`, { replace: true })
      return
    }

    // 2. If no localStorage, navigate to default (Spanish)
    navigate('/es', { replace: true })
  }, [navigate])

  // Fallback for no JavaScript
  return (
    <noscript>
      <meta httpEquiv='refresh' content='0; url=/es' />
    </noscript>
  )
}
